import Vue from "vue"
Vue.config.productionTip = false

import vueCustomElement from "vue-custom-element"
// Widgets
import HgNavbarWidget from "./HgNavbarWidget.vue"
import HgFooterWidget from "./HgFooterWidget.vue"
import HgAmadeusSearchWidget from "./HgAmadeusSearchWidget.vue"
import HgNetmatchSearchWidget from "./HgNetmatchSearchWidget.vue"
import HgTopbarWidget from "./HgTopbarWidget.vue"

import * as components from "@holidayguru/holidayguru-components"
import "@holidayguru/holidayguru-components/dist/holidayguru-components.css"
import "./styles.css"

// Font Awesome
import "./plugins/font-awesome"

// Validate
import "./plugins/vee-validate"

// i18n
import { i18n } from "./plugins/vue-i18n"

// Apollo
import { apolloProvider } from "./plugins/apollo"

// Components
Object.keys(components).forEach((componentName) => {
  Vue.component(componentName, components[componentName])
})

// Injects
HgAmadeusSearchWidget.apolloProvider = apolloProvider
HgNetmatchSearchWidget.apolloProvider = apolloProvider

HgNavbarWidget.i18n = i18n
HgFooterWidget.i18n = i18n
HgAmadeusSearchWidget.i18n = i18n
HgNetmatchSearchWidget.i18n = i18n
HgTopbarWidget.i18n = i18n

// Installation
Vue.use(vueCustomElement)
Vue.customElement("hg-navbar-widget", HgNavbarWidget)
Vue.customElement("hg-footer-widget", HgFooterWidget)
Vue.customElement("hg-amadeus-search-widget", HgAmadeusSearchWidget)
Vue.customElement("hg-netmatch-search-widget", HgNetmatchSearchWidget)
Vue.customElement("hg-topbar-widget", HgTopbarWidget)
